module.exports = __webpack_public_path__ + "img/DW_hzhb.8efba415.jpg";